module.exports = __webpack_public_path__ + "img/larne-logo-icon.55d8ef8e.png";